




























































































































































































import {
  CheckoutContractDurationList,
  CheckoutLocationList,
  CheckoutPrice,
  CheckoutUnit,
} from '../../component/checkout/stepone';
import {
  AtlasCheckoutInfo,
  BlackwakeCheckoutInfo,
  HellLetLooseGameInfo,
  HurtworldCheckoutInfo,
  RustCheckoutInfo,
  FrozenFlameCheckoutInfo,
  IcarusCheckoutInfo,
  EnshroudedCheckoutInfo,
} from '../../component/checkout/infos';

import OrderNavBar from '../../component/navigation/OrderNavBar.vue';
import { ExtensionPrice, PriceRequest, PriceResponse } from '@a/store/price/types';
import TrustSymbols from '../../component/checkout/global/TrustSymbols.vue';
import CustomerAdvantages from '../../component/checkout/global/CustomerAdvantages.vue';
import CustomerSupportInfo from '../../component/checkout/global/CustomerSupportInfo.vue';
import PaymentMethods from '../../component/checkout/global/PaymentMethods.vue';
import LoadingAnimation from '../../component/helper/LoadingAnimation.vue';
import {
  ProductResponse,
  ProductServer,
  ProductServerDuration,
  ProductServerLocation,
} from '@a/store/product/types';
import VueSmartSlider from '../../component/ui/slider/VueSmartSlider.vue';
import { SliderMarker } from '@c/ui/slider/types/SliderTypes';
import RegionSwitcherModal from '../../component/footer/RegionSwitcherModal.vue';
import { TrackingEventTypes } from '@a/plugins/tracking/types/tracking';
import WarOfRightsCheckoutInfo from '../../component/checkout/infos/WarOfRightsCheckoutInfo.vue';
import ModpackSearchInput from '@a/component/landingpage/modpack/ModpackSearchInput.vue';
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useStore } from '@a/store';
import { useRouter } from '@a/composables/use-router';
import { useTracking } from '@a/plugins/tracking';
import { useConfigurationApi } from '@a/plugins/configuration';
import { useI18N } from '@a/composables/use-vue-i18n';
import { useToast } from 'vue-toastification/composition';
import { debounce } from '@a/helper/event-control';
import { SelectedExtension } from '@c/checkout/stepone/extension/types';
import BaseToastTemplate from '@c/toast/BaseToastTemplate.vue';
import { BaseToastTypeEnums } from '@c/toast/BaseToastTemplateUse';
import VRisingCheckoutInfo from '@c/checkout/infos/VRisingCheckoutInfo.vue';
import ArkSurvivalCheckoutInfo from '@c/checkout/infos/ArkSurvivalCheckoutInfo.vue';
import AbioticFactorCheckoutInfo from '@c/checkout/infos/AbioticFactorCheckoutInfo.vue';
import FiveMCheckoutInfo from '@c/checkout/infos/FiveMCheckoutInfo.vue';

export default defineComponent({
  name: 'TheStepOneView',
  components: {
    AbioticFactorCheckoutInfo,
    ArkSurvivalCheckoutInfo,
    VRisingCheckoutInfo,
    EnshroudedCheckoutInfo,
    BaseExtensionSelection: () => import(/* webpackChunkName: "vue.stepone.extensions" */'@c/checkout/stepone/extension/BaseExtensionSelection.vue'),
    WarOfRightsCheckoutInfo,
    RegionSwitcherModal,
    VueSmartSlider,
    LoadingAnimation,
    PaymentMethods,
    CustomerAdvantages,
    TrustSymbols,
    BlackwakeCheckoutInfo,
    HellLetLooseGameInfo,
    HurtworldCheckoutInfo,
    RustCheckoutInfo,
    AtlasCheckoutInfo,
    FrozenFlameCheckoutInfo,
    IcarusCheckoutInfo,
    FiveMCheckoutInfo,
    CheckoutPrice,
    CheckoutContractDurationList,
    CheckoutUnit,
    OrderNavBar,
    CheckoutLocationList,
    ModpackSearchInput,
    MinecraftRamUnitSelect: () => import(/* webpackChunkName: "vue.stepone.minecraft" */'./stepone/MinecraftRamUnitSelect.vue'),
  },
  props: {
    /**
     * used by the debounce, can be configured on the router level
     */
    priceTimeout: {
      type: Number,
      required: true,
    },
  },
  setup: (props) => {
    const store = useStore();
    const config = useConfigurationApi();
    const tracking = useTracking();
    const i18n = useI18N();
    const toast = useToast();
    const { route, router } = useRouter();
    const state = reactive({
      selectedUnits: undefined as number,
      selectedDuration: undefined as ProductServerDuration,
      selectedLocation: undefined as ProductServerLocation,
      regionModalVisible: false,
      product: computed<ProductResponse>(() => store.getters['product/product']),
      productLocations: computed<Array<ProductServerLocation>>(() => store.getters['product/locations']),
      minUnits: computed<number>(() => store.getters['product/minUnits']),
      maxUnits: computed<number>(() => store.getters['product/maxUnits']),
      sliderValues: computed<Array<number>>(() => store.getters['product/sliderValues']),
      hasContract: computed<boolean>(() => store.getters['price/hasContract']),
      price: computed<PriceResponse>(() => store.getters['price/price']),
      extensionPrices: computed<Array<ExtensionPrice>>(() => store.getters['price/extensionPrices']),
      isOrderProductLoading: computed<boolean>(() => store.getters['product/isOrderProductLoading']),
      isOrderProductFailure: computed<boolean>(() => store.getters['product/isOrderProductFailure']),
      isOrderProductAvailable: computed<boolean>(() => store.getters['product/isOrderProductAvailable']),
      isOrderProductPriceLoading: computed<boolean>(() => store.getters['price/isProductPriceLoading']),
      productKey: computed<string>(() => ('productKey' in route.value.params
        ? route.value.params.productKey
        : null)),
      selectedExtensions: [],
    });

    /**
     * template ref for order step one form
     */
    const orderStepOneForm = ref<HTMLFormElement>(null);

    /**
     * ajax call which fetches the price
     * @param payload
     */
    const fetchPrice = (payload: PriceRequest) => store.dispatch('price/fetchPrice', payload);

    /**
     * updates the price with the needed parameters
     */
    const updatePrice = (): void => {
      if (!state.selectedUnits || !state.selectedLocation || !state.selectedDuration) {
        throw new TypeError('units, location or duration is not set correctly!');
      }

      fetchPrice({
        productKey: state.productKey,
        units: state.selectedUnits,
        duration: state.selectedDuration.duration,
        locationKey: state.selectedLocation.key,
        extras: state.selectedExtensions,
      });
    };

    /**
     * debounced version of updatePrice
     */
    const debounceUpdatePrice = debounce(updatePrice, props.priceTimeout);

    /**
     * when the selected duration has been changed
     */
    const selectedDurationUnwatchHandle = watch(() => state.selectedDuration,
      () => {
        debounceUpdatePrice();
      });

    /**
     * when the selected location has been changed
     */
    const selectedLocationUnwatchHandle = watch(() => state.selectedLocation,
      (cur: ProductServerLocation) => {
        tracking.track({
          event: TrackingEventTypes.COS1_BG_LOCATION,
          data: {
            type: 'buttongroup',
            value: cur.key,
            productKey: state.productKey,
          },
        });

        // update selected duration to reflect the duration discount for this location
        for (const duration of cur.product.durations) {
          if (duration.duration === state.selectedDuration.duration) {
            state.selectedDuration = duration;
          }
        }

        debounceUpdatePrice();

        // show sold-out toast message
        if (!state.selectedLocation.available) {
          toast.error({
            component: BaseToastTemplate,
            props: {
              type: BaseToastTypeEnums.DANGER,
              title: i18n.t('general:error.text'),
              text: i18n.t('checkout:stepone.soldout'),
            },
          });
        }
      });

    /**
     * when the units has been changed we want to make sure that we really need the call
     */
    const selectedUnitsUnwatchHandle = watch(() => state.selectedUnits, (cur) => {
      if (state.price && state.price.slots !== cur) {
        debounceUpdatePrice();
      }
    });

    const selectedExtensionsUnwatchHandle = watch(() => state.selectedExtensions, () => {
      debounceUpdatePrice();
    });

    onMounted(() => {
      const { data: { payment: { basket } } } = config;

      state.selectedUnits = basket.units;

      router.onReady(() => {
        store
          .dispatch('product/fetchProduct', { productKey: state.productKey })
          .then((orderProduct: ProductResponse) => {
            const { locations } = orderProduct;

            state.selectedLocation = locations.find(
              (l) => l.key === basket.location,
            );

            state.selectedDuration = state.selectedLocation.product.durations.find(
              (d) => d.duration === basket.durationDays,
            );

            // --- map the extensions of the basket into the components state
            if (basket.extensions != null
              && basket.extensions.filter((extension) => extension.showAtOrder).length
            ) {
              state.selectedExtensions = basket.extensions
                .filter((extension) => extension.showAtOrder)
                .map<SelectedExtension<number>>((extension) => ({
                key: extension.key,
                value: extension.units,
              }));
            }
          });
      });
    });

    onUnmounted(() => {
      selectedUnitsUnwatchHandle();
      selectedLocationUnwatchHandle();
      selectedDurationUnwatchHandle();
      selectedExtensionsUnwatchHandle();
    });

    /**
     * gets called when the region switcher is visible through the OS1
     * and the customer accepts it, then the form is submitted (POST)
     */
    const onRegionSwitcherModalAccept = (): void => {
      state.regionModalVisible = false;
      orderStepOneForm.value.submit();
    };

    /**
     * event which gets called when the order is submitted
     */
    const onOrderSubmit = (): void => {
      tracking.track({
        // --- if the customer has a SAVED PM he used the "change payment method"
        // --- button, if not the used continue
        event: state.hasContract
          ? TrackingEventTypes.COS1_LNK_CHANGE_PAYMENT_METHOD
          : TrackingEventTypes.COS1_BTN_BUY_CONTINUE,
        data: {
          type: 'button',
          productKey: state.productKey,
          target: 'FORM',
        },
      });
    };

    /**
     * simple slider options (width 1000 because of our side-content-size)
     */
    const sliderOptions = {
      width: 1000,
      floats: false,
    };

    /**
     * returns the slider marker (or just items) computed because the actual slider values
     * can possibly change
     */
    const sliderMarker = computed<Array<SliderMarker>>(() => state.sliderValues
      .map<SliderMarker>((sliderValue: number, index: number, values) => ({
      id: index,
      percentage: (index / (values.length - 1) * 100),
      value: sliderValue,
    })));

    /**
     * fancy untranslated loading titles for step one
     */
    const loadingTitles: string[] = [
      'Just count to 10',
      'Are we there yet?',
      'Convincing AI not to turn evil..',
      'May the forks be with you',
      'Winter is coming...',
    ];

    /**
     * just a random loading title picker
     */
    const getFancyLoadingTitle = () => loadingTitles[
      Math.floor(Math.random() * loadingTitles.length)
    ];

    /**
     * when the customer support info shall be displayed
     */
    const shouldDisplayCustomerSupportInfo = (): boolean => config.data.region.shortName === 'EU';

    /**
     * vat required?
     */
    const shouldDisplayVat = (): boolean => config.data.vat.required;

    /**
     * returns true when a region switch is required
     */
    const regionSwitchRequired = computed<boolean>(() => state.selectedLocation !== undefined
      && state.selectedLocation.switchRegion === true);

    return {
      i18n,
      route,
      state,
      sliderOptions,
      sliderMarker,
      regionSwitchRequired,
      shouldDisplayVat,
      shouldDisplayCustomerSupportInfo,
      getFancyLoadingTitle,
      onOrderSubmit,
      onRegionSwitcherModalAccept,
    };
  },
});

